import { render } from "./SelfReviewForm.vue?vue&type=template&id=3ced565e&scoped=true"
import script from "./SelfReviewForm.vue?vue&type=script&lang=js"
export * from "./SelfReviewForm.vue?vue&type=script&lang=js"

import "./SelfReviewForm.vue?vue&type=style&index=0&id=3ced565e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ced565e"]])

export default __exports__